const config = window.envConfig;

if (process.env.BUILD_MODULE === "agyle") {
    config.apiUrl = config.apiUrlAgyle;
}

export default config;
